/**
 * 팝업 이벤트 비콘(§16) — navigator.sendBeacon → fetch(keepalive) 폴백.
 * impression 은 페이지 세션당 팝업별 1회로 중복 억제. 실패는 조용히 무시(페이지 영향 없음).
 */
export class PopupAnalytics {
    private endpoint: string;
    private locale: string;
    private device: string;
    private impressed = new Set<number>();

    constructor(endpoint: string, locale: string, device: string) {
        this.endpoint = endpoint || "/popups/event";
        this.locale = locale;
        this.device = device;
    }

    record(id: number, event: string): void {
        try {
            if (event === "impression") {
                if (this.impressed.has(id)) return;
                this.impressed.add(id);
            }
            const form = new URLSearchParams();
            form.append("popup_id", String(id));
            form.append("event", event);
            form.append("locale", this.locale);
            form.append("device", this.device);

            let sent = false;
            if (typeof navigator !== "undefined" && navigator.sendBeacon) {
                const blob = new Blob([form.toString()], { type: "application/x-www-form-urlencoded;charset=UTF-8" });
                sent = navigator.sendBeacon(this.endpoint, blob);
            }
            if (!sent && typeof window.fetch === "function") {
                window.fetch(this.endpoint, {
                    method: "POST",
                    body: form,
                    keepalive: true,
                    credentials: "same-origin",
                    headers: { "X-Requested-With": "fetch" },
                }).catch(() => { /* noop */ });
            }
        } catch {
            /* 통계 실패는 무시 */
        }
    }
}
